import Component from "./TemplatePage";
export default Component;
